<template>
    <div>
        <swb-query-sort-area name="query-sort-area" ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :queryKey="queryKey" :queryHandler="queryHandler"></swb-query-sort-area>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { getDevcGroupNameByCatId } from '../index'
    //
    import assetVchrApi from '../../api/assetVchr'
    //
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-shop-device-trans-voucher-item-select',
        desc: '资产调拨项选择',
        props: {
            id: {
                type: Number,
                default: null,
            },
            selectIds: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                confKey: "swb-shop-device-trans-voucher-item-select",
                tableHeight: 460,
                queryOnLoad: false,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 300,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //排序、搜索
                queryKey: null,
                comId: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
            }
        },
        created: function () {
            this.getTransVoucherItemList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass("overFlow-hidden");
            //
            this.initResultTable();
            //
            let initChecked = this.selectIds;
            let resultTable = this.$refs['result_table'];
            resultTable.setInitChecked(initChecked, false);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            getAllotAcntMethod(value){
                return getEnumInfoWith('allotAcntMethod', 'value', value).text;
            },
            getAcctEnterWay(value){
                return getEnumInfoWith('acctEnterWay', 'value', value).text;
            },
            assetTypeMap(value){
                return getEnumInfoWith('assetType', 'value', value).text;
            },
            getAllotAcntType(value){
                return getEnumInfoWith('allotAcntType', 'value', value).text;
            },
            onConfigReady: function () {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
            },
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                let resultTable = this.$refs['result_table'];
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'allotAcntMethod': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.allotAcntMethod != null) {
                            return self.allotAcntMethod(row.allotAcntMethod);
                        }
                    },
                    'allotAcntType': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null) {
                            return self.getAllotAcntType(colValue);
                        }
                    },
                    'acctEnterWay': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null) {
                            return self.getAcctEnterWay(colValue);
                        }
                    },
                    'assetType': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null) {
                            return self.assetTypeMap(colValue);
                        }
                    },
                    'groupName': function (row, colName, colValue, rowIndex, colConf) {
                        let devcGroup = self.getGoodsCatDevcGroupName(row.catId) || "";
                        //
                        return '<span>' + devcGroup + '</span>';
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                });
            },
            renderTable(rows, pagination, resultTable) {
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            //回显数据处理
            handleInitChecked(initChecked, resultTable) {
                //
                resultTable.setInitChecked(initChecked, true);
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getTransVoucherItemList();
            },
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                //缓存查询条件
                this.pageNumber = 1;
                this.getTransVoucherItemList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getTransVoucherItemList();
            },
            getTransVoucherItemList: function () {
                let self = this;

                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.voucherId = self.id;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                assetVchrApi.getShopDeviceTransVoucherItemList(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let deviceItemList = result.data.rows || [];
                        // 查询已验收、已退还的数量
                        self.getTransReceiptOrDirectQuantity(function (resultData) {
                            let receiptQuantityMap = resultData.receiptQuantityMap || {};
                            let directQuantityMap = resultData.directQuantityMap || {};
                            let diabledIds = [];
                            if(deviceItemList.length > 0) {
                                deviceItemList.forEach(function (item) {
                                    let receiptQuantity = 0;
                                    if(!Utils.isNoB(receiptQuantityMap) && receiptQuantityMap[item.id] != null) { // 已验收
                                        receiptQuantity = receiptQuantityMap[item.id];
                                        diabledIds.push(item.id);
                                    }
                                    let directQuantity = 0;
                                    if(!Utils.isNoB(directQuantityMap) && directQuantityMap[item.id] != null) { // 已退还
                                        directQuantity = directQuantityMap[item.id];
                                        if(diabledIds.indexOf(item.id) < 0) {
                                            diabledIds.push(item.id);
                                        }
                                    }
                                    item.receiptQuantity = receiptQuantity;
                                    item.directQuantity = directQuantity;
                                })
                            }
                            //
                            let pagination = result.data.pagination;
                            //
                            let resultTable = self.$refs.result_table;
                            self.renderTable(deviceItemList, pagination, resultTable);
                            self.handleInitChecked(diabledIds, resultTable);
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTransReceiptOrDirectQuantity: function (callBack) {
                let self = this;
                let postData = {
                    transVoucherId: self.id
                };
                let theLoad = MsgBox.loading();
                assetVchrApi.getTransReceiptOrDirectQuantity(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        callBack(result.data);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getDlgResult: function () {
                let result = {};
                result.type = 'info';
                // ---------
                let itemList = this.getTableSelection() || [];
                let resultList = [];
                if(itemList.length > 0) {
                    itemList.forEach(function (item) {
                        if(!Utils.isNoB(item.deviceXId)) {
                            resultList.push(item);
                        }
                    });
                }
                if(resultList.length > 0) {
                    result.data = resultList;
                } else {
                    result.type = 'warn';
                    result.message = "请选择资产信息！";
                }
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherItemSelect.vue